import React from "react";
import { CGE } from "../../../../common/components/CGE";
import { useModal } from "@clayui/modal";

function Contingency({ state, funcClick }) {
    const [visibleModal, setVisibleModal] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
        }
    });
    var secText = <>
        <a className="cge-tag-a-style" onClick={() => funcClick(2)}>aquí</a>.
    </>

let propsLabelInfoContent = {
    "content": state?.webContentTextInfo,
    "observer": observer,
    "onClose": onClose,
    "setVisibleModal": setVisibleModal,
    "status": "info",
    "titleModal": "Información",
    "visibleModal": visibleModal,
    "titleHint": "Ayuda Nro de Cliente",
}

    return (
        <div class="align-items-center">
            <CGE.Panel title="Contingencia">
                <CGE.PanelSectionTicket title={"Información del cliente"}>
                    <CGE.DetailClient
                        props={{
                            idClient: state?.idCtaCto,
                            idFormElement: "numberClient",
                            labelName: "Número de Cliente:",
                            placeholder: "Número de Cliente",
                            valuePub: state?.idCtaCto,
                            readOnly: true,
                            propsLabelInfoContent:propsLabelInfoContent
                        }}  
                        helpText={false}
                        propsDetail={{
                            fullNameClient: "",
                            comunaClient: state?.estaSinLuz?.comuna ? state?.estaSinLuz?.comuna : "",
                            calleClient: state?.estaSinLuz?.dirCalle ? state?.estaSinLuz?.dirCalle : "",
                            nCalleClient: state?.estaSinLuz?.dirNumero ? state?.estaSinLuz?.dirNumero : "",
                            dptoBlockClient: state?.estaSinLuz?.dirDpto ? state?.estaSinLuz?.dirDpto : "",
                            ctaCtoClient: state?.idCtaCto
                        }}
                    />
                </CGE.PanelSectionTicket>
                <CGE.PanelSectionTicket>
                    <div class="row rounded">
                        <div class="col-md-12">
                            <CGE.Spacing type="ct"/>   
                            <CGE.Text
                                text={state?.estaSinLuz?.interrupcion?.motivoFalla}
                                size="7"
                                style={{ color: 'black' }}
                            />
                            <br />
                        </div>

                        {state?.estaSinLuz?.interrupcion?.horaSolucionEstimada && <div class="col-md-12">
                            <CGE.Text
                                text={state?.estaSinLuz?.interrupcion?.horaSolucionEstimada}
                                size="7"
                                secText={'.'}
                                style={{ color: 'black' }}
                            />
                            <br />
                        </div>}

                        {state?.estaSinLuz?.puedeIngresarTicket && <div class="col-md-12">
                            <CGE.Text
                                text={`Si desea informar su contingencia, por favor ingrese `}
                                size="7"
                                secText={secText}
                                style={{ color: 'black' }}
                            />
                        </div>}
                        {!state?.estaSinLuz?.puedeIngresarTicket &&
                            <div class="col-md-12">
                                <CGE.Text
                                    text={state?.estaSinLuz?.mesajeInterrupcion}
                                    size="7"
                                    style={{ color: 'black' }}
                                />
                            </div>}

                    </div>
                </CGE.PanelSectionTicket>
                <div class="d-flex justify-content-center">
                            <CGE.Button
                                label="Volver"
                                onClick={() => funcClick(0)}
                                type="primary"
                            />
                </div>
            </CGE.Panel>
        </div>
    );
};

export default Contingency;